<template>
    <div v-if="product && product.id !== productId">
        <div class="notice mt-5">
            <i class="fa fa-info-circle fa-lg mr-4"></i> Dit product verdwijnt binnenkort uit ons assortiment, <a :href="'/products/' + product.Slug ">klik hier om naar de opvolger van dit product te gaan.</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'productId',
            'supplierId',
        ],

        /*
         * The component's data.
         */
        data() {
            return {
                product: null
            };
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {

                this.getSuccessor();


            },


            getSuccessor: function() {
                axios.get('/api/products/' + this.productId + '/successor')
                    .then(response => {
                        this.loading = false;
                        if(typeof response.data.Id !== 'undefined' && parseInt(this.productId) !== response.data.Id) {
                            this.product = response.data;
                        }
                    });
            },
        }
    }
</script>


